export const utils = {
  debounce,
  convertBase64ToBlob,
  stringToNumber,
  formatCurrency,
  isStringOk,
  stringToASCII,
  formatDatetime,
  getTimeOffset,
  isVideo,
};

function debounce(func: any, wait: number) {
  let timeout: NodeJS.Timeout;
  return function (...args: any[]) {
    clearTimeout(timeout);
    // @ts-ignore
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

function convertBase64ToBlob(base64: string) {
  const arr = base64.split(",");
  const mime = arr[0].match(/:(.*?);/)![1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}

function formatCurrency(val: any, prefix: string = "") {
  if (Number.isNaN(Number.parseFloat(val))) {
    val = 0;
  }
  let value = val ? `${val}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : `0`;
  return `${prefix}${value}đ`;
}

function stringToNumber(val: string) {
  let result: any = `${val || "0"}`.replace(/\$\s?|(,*)/g, "");
  return result - 0;
}

function isStringOk(s: string) {
  return s !== null && s !== "null" && s !== undefined && s !== "" && s !== `""` && s !== "undefined";
}

function formatDatetime(value: string) {
  return value; // moment(value, "")
}

function stringToASCII(str: string) {
  try {
    return str
      .toLowerCase()
      .replace(/[àáảãạâầấẩẫậăằắẳẵặ]/g, "a")
      .replace(/[èéẻẽẹêềếểễệ]/g, "e")
      .replace(/[đ]/g, "d")
      .replace(/[ìíỉĩị]/g, "i")
      .replace(/[òóỏõọôồốổỗộơờớởỡợ]/g, "o")
      .replace(/[ùúủũụưừứửữự]/g, "u")
      .replace(/[ỳýỷỹỵ]/g, "y");
  } catch (e) {
    return "";
  }
}

function getTimeOffset() {
  const offset = new Date().getTimezoneOffset();
  const absOffset = Math.abs(offset);
  const hours = String(Math.floor(absOffset / 60)).padStart(2, "0");
  const minutes = String(absOffset % 60).padStart(2, "0");
  const sign = offset <= 0 ? "+" : "-";
  return `${sign}${hours}:${minutes}`;
}

function isVideo(src: string) {
  return /\.(mp4|webm|ogg)$/i.test(src);
}
